import React, { useEffect, useState } from 'react';
import { Table } from "antd";
import styled, { withTheme } from "styled-components";
import hexToRgba from 'hex-to-rgba';
import { Flex, FlexColumn } from './Container';
import { Divider } from './Input';
import { Text } from './Text';
import { random } from 'underscore';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

import ChevronDownPrimary from "../../Images/chevron-down.svg"
import ChevronDown from "../../Images/chevron-down.png"
import ChevronUp from "../../Images/chevron-up.png"
import { TextButton, ImageButton } from './Button';

const StyledTable = styled(Table)`
    height: 100%;
    div {
        background: transparent;
    }
    table {
        border-bottom: ${props => props.showBottomBorder && `1px solid rgba(0, 0, 0, 0.05) !important`};
    }
    thead > tr {
        border-radius: 8px;
        box-shadow: ${props => !props.borderView && `0px 0px 2px rgba(0, 0, 0, 0.1)`};
        background: transparent;
    }
    thead > tr > th {
        background: ${props => props.theme.colors.container};
        color: ${props => hexToRgba(props.theme.colors.primary2, 0.5)};
        border-bottom: ${props => props.borderView && `1px solid ${props.theme.colors.border}`};
        padding: 10px 20px !important; /* Maintain consistent header height */
        height: 50px !important; /* Fixed height to match original */
    }
    thead > tr > th:first-child {
        border-bottom-left-radius: 8px;
        border-left: ${props => props.borderView && `1px solid ${props.theme.colors.border}`};
    }
    thead > tr > th:last-child {
        border-bottom-right-radius: 8px;
        padding-right: 20px;
        border-right: ${props => props.borderView && `1px solid ${props.theme.colors.border}`};
    }
    
    /* Hide antd's default sort icons */
    .ant-table-column-sorter {
        display: none !important;
    }
    
    /* Style for the column that is currently sorted */
    th.sorted-column {
        color: ${props => props.theme.colors.primary2} !important;
    }
    
    /* Style for sortable columns */
    th.sortable-column {
        cursor: pointer;
        height: 35px;
        padding: 0px 0px !important
    }
    
    /* Add hover effect to sortable columns */
    th.sortable-column:hover {
        background-color: ${props => hexToRgba(props.theme.colors.primary, 0.05)} !important;
    }
    
    /* Rest of your existing styles */
    thead > tr {
        border-radius: 8px;
        background: transparent;
    }
    tbody > tr > td {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        border-bottom: ${props => !props.borderView && `none !important`};
        height: 55px !important;
    }
    tbody > tr > td:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }
    tbody > tr > td:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }
    /* Hover effects for row expansion */
    tbody > tr:hover > td:first-child {
        border-left: ${props => props.expand ? `4px solid ${hexToRgba(props.theme.colors.primary2, 0.7)}` : 'none'};
    }
    
    /* The blue left border for expanded row parent */
    .expanded-parent > td:first-child {
        border-left: ${props => `4px solid ${hexToRgba(props.theme.colors.primary2, 0.7)}`} !important;
    }

    tbody > tr:not(.expanded-row):hover {
        background: ${props => props.dataCount > 0 ? hexToRgba(props.theme.colors.primary, 0.06) : 'transparent'};
        cursor: ${props => props.onRow ? 'pointer' : 'auto'};
    }
    tr {
        color: ${props => hexToRgba(props.theme.colors.primary2, 1.0)};
    }
    .odd-row {
        border-radius: 8px;
        background-color: ${props => !props.disableAltRowBg && props.theme.colors.container}; /* white bg for alternate rows */
        box-shadow: ${props => !props.borderView && `0px 0px 2px rgba(0, 0, 0, 0.1)`};
    }
    .odd-row > td {
        border-top: ${props => props.borderView && `1px solid ${props.theme.colors.border}`};
        border-bottom: ${props => props.borderView && `1px solid ${props.theme.colors.border}`};
    }
    .odd-row > td:first-child {
        border-left: ${props => props.borderView && `1px solid ${props.theme.colors.border}`};
    }
    .odd-row > td:last-child {
        border-right: ${props => props.borderView && `1px solid ${props.theme.colors.border}`};
    }
    
    .odd-row.expanded-parent > td:first-child {
        border-bottom-left-radius: 0px !important;
        border-left: ${props => `4px solid ${hexToRgba(props.theme.colors.primary2, 0.7)}`};
    }
    
    .odd-row.expanded-parent > td:last-child {
        border-bottom-right-radius: 0px !important;
    }
    
    // In case the last row is an odd row, show row border
    .odd-row:last-child > td {
        border-bottom: ${props => props.borderView && `1px solid ${props.theme.colors.border} !important`};
    }
    
    .even-row > td {
        border-bottom: ${props => props.borderView && `none !important`};
    }
    
    .even-row.expanded-parent {
        /* border-bottom: 0.1px solid rgba(0, 0, 0, 0.05) !important; */
        box-shadow: 0px 0.3px 0px rgba(0, 0, 0, 0.1);
    }
    
    .even-row.expanded-parent > td {
        /* border-bottom: 0.1px solid rgba(0, 0, 0, 0.05) !important; */
    }
    
    .even-row.expanded-parent > td:first-child {
        border-bottom-left-radius: 0px !important;
        border-left: ${props => `4px solid ${hexToRgba(props.theme.colors.primary2, 0.7)}`};
    }
    
    .even-row.expanded-parent > td:last-child {
        border-bottom-right-radius: 0px !important;
    }

    .expanded-row > td {
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
        border-left: ${props => `4px solid ${hexToRgba(props.theme.colors.primary2, 0.7)}`};
        padding: 20px !important;
    }
    
    /* Remove the wrapper content div and restore the original behavior */
    tbody > tr.expanded-row.odd-row > td {
        background-color: ${(props) => props.theme.colors.container};
    }
    
    tbody > tr.expanded-row.even-row > td {
        background: transparent;
    }
    
    tbody > tr.expanded-row.odd-row:hover > td {
        background-color: ${(props) => props.theme.colors.container};
        cursor: default !important;
    }
    
    tbody > tr.expanded-row.even-row:hover {
        background: transparent;
        cursor: default !important;
    }
    
    tbody > tr.expanded-row.odd-row:hover > td {
        background-color: ${(props) => props.theme.colors.container};
        cursor: default !important;
    }
    
    tbody > tr > td.hover-column > * {
        visibility: hidden;
    }

    tbody > tr:hover > td.hover-column > * {
        visibility: visible;
    }

    tbody > tr > td.primary-column {
        /* font-size: 14px; */
    }

    /* 
        USE CASES
        1. Use hover-content is similar to show-on-hover. hover-content maintains width of column but only shows something on hover
        2. Use show-on-hover when using with hide-on-hover. Both go hand in hand by showing different content on hover and without hover
     */

    .cell-content .hover-content {
        visibility: hidden;
    }

    tbody > tr:hover .cell-content .hover-content {
        visibility: visible;
    }

    .cell-content .show-on-hover {
        visibility: hidden;
        display: none;
    }

    tbody > tr:hover .cell-content .show-on-hover {
        visibility: visible;
        display: inline-block;
    }

    .cell-content .hide-on-hover {
        visibility: visible;
        display: inline-block;
    }

    tbody > tr:hover .cell-content .hide-on-hover {
        visibility: hidden;
        display: none;
    }

    td.ant-table-column-sort {
        background: inherit;
    }

    // To hide the table header
    ${props => props.hideHeader && `
        .ant-table-thead {
            display: none;
        }
    `}

    .group-header {
        background-color: ${props => hexToRgba(props.theme.colors.container, 0.5)} !important; /* Grey background color for group header */
        font-weight: 400;
        border-radius: 0px;
        box-shadow: 0px 0px 0px !important;
    }
    .group-header > td {
        padding: 8px 20px;
        border-radius: 0px;
    }

    /* Remove antd's background color when column is sorted */
    td.ant-table-column-sort {
        background: inherit !important;
    }

    /* Also remove the sorting background color in the header */
    th.ant-table-column-sort {
        background: ${props => props.theme.colors.container} !important;
    }
`;

const StyledHeader = styled.div`
    background: ${props => props.theme.colors.container};
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    border-bottom-right-radius: ${props => props.isCollapsed && '8px'};
    border-bottom-left-radius: ${props => props.isCollapsed && '8px'};
    border: ${props => props.borderView && `1px solid ${props.theme.colors.border}`};
    border-bottom: none;
    box-shadow: ${props => !props.borderView && `0px 0px 2px rgba(0, 0, 0, 0.1)`};
`;

// Custom title renderer component for column headers
const CustomColumnTitle = ({ title, sortOrder, sortField, columnKey, theme, isSortable }) => {
    const isSorted = sortField === columnKey;
    return (
        <Flex centerH between gap='4px'>
            <span>{title}</span>
            {isSortable && (
                isSorted ? (
                    <Flex center style={{ backgroundColor: hexToRgba(theme.colors.primary, 0.08), borderRadius: '4px', padding: '4px' }}>
                        {sortOrder === 'ascend' ? (
                            <ArrowUp size={16} color={hexToRgba(theme.colors.primary2, 0.8)} />
                        ) : (
                            <ArrowDown size={16} color={hexToRgba(theme.colors.primary2, 0.8)} />
                        )}
                    </Flex>
                ) : (
                    <ArrowUpDown 
                        size={14} 
                        color={hexToRgba(theme.colors.primary2, 0.4)} 
                        style={{ opacity: 0.7 }}
                    />
                )
            )}
        </Flex>
    );
};

const TableView = (props) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [canCollapse, setCanCollapse] = useState(false);
    
    // Convert API field name format to component dataIndex format
    const formatFieldForComponent = (apiFieldName) => {
        if (!apiFieldName) return '';
        return apiFieldName.charAt(0).toLowerCase() + apiFieldName.slice(1);
    };
    
    // Initialize sort state
    const [sortInfo, setSortInfo] = useState({
        field: formatFieldForComponent(props.sortFieldName) || '',
        order: props.sortDirection === 'ASC' ? 'ascend' : 'descend'
    });
    
    const { 
        theme, 
        titleText, 
        descText, 
        ctaContent, 
        ctaSecondary, 
        pagination, 
        expandedRowKey, 
        rowKey, 
        onLoadMore, 
        moreToLoad, 
        loadingMore, 
        pageSize, 
        hideHeader, 
        bottomDivider 
    } = props;

    if (pagination) pagination['hideOnSinglePage'] = true;
    var dataRows = (props.dataSource || []).filter(item => !['sectionHeader', 'dateRow'].includes(item[rowKey]));
    
    useEffect(() => {
        if (props.canCollapse == true) {
            setIsCollapsed(props.isCollapsed);
            setCanCollapse(true);
        }
        
        // Set initial sort state based on props whenever they change
        if (props.sortFieldName) {
            setSortInfo({
                field: formatFieldForComponent(props.sortFieldName),
                order: props.sortDirection === 'ASC' ? 'ascend' : 'descend'
            });
        }
    }, [props.canCollapse, props.isCollapsed, props.sortFieldName, props.sortDirection]);

    // Determine the opposite sort direction for toggling
    const getOppositeSortDirection = (direction) => {
        return direction === 'ASC' ? 'descend' : 'ascend';
    };

    // Set sortDirections based on the initial direction
    const initialSortOrder = props.sortDirection === 'ASC' ? 'ascend' : 'descend';
    const oppositeSortOrder = getOppositeSortDirection(props.sortDirection);
    
    // Dynamically set the sort directions array based on the current sort direction
    const sortDirectionsArray = [oppositeSortOrder, initialSortOrder];

    // Track sort changes
    const handleTableChange = (pagination, filters, sorter, extra) => {
        // console.log("pagination, filters, sorter, extra", pagination, filters, sorter, extra)
        if (sorter && sorter.field && extra && extra.action === 'sort') {
            // If we're sorting the same column that was already sorted
            if (sortInfo.field === sorter.field) {
                // Force toggle between ascend and descend (avoid antd's 3-state behavior)
                const newOrder = sortInfo.order === 'ascend' ? 'descend' : 'ascend';
                setSortInfo({
                    field: sorter.field,
                    order: newOrder
                });
                
                // Update the sorter object to pass to parent handler
                sorter.order = newOrder;
            } else {
                // Different column, use the provided order or default to descend
                setSortInfo({
                    field: sorter.field,
                    order: sorter.order || 'descend'
                });
            }
        }
        
        // Call the parent's handler if provided
        if (props.onChange) {
            props.onChange(pagination, filters, sorter);
        }
    };
    
    // First apply custom sort icons to columns
    const columnsWithSortIcons = (props.columns || []).map(column => {
        // Create a copy of the column to avoid modifying the original
        const newColumn = { ...column };
        
        if (column.sorter) {
            newColumn.title = () => (
                <CustomColumnTitle 
                    title={column.title} 
                    sortOrder={sortInfo.field === column.dataIndex ? sortInfo.order : null}
                    sortField={sortInfo.field}
                    columnKey={column.dataIndex}
                    theme={theme}
                    isSortable={true}
                />
            );
            newColumn.className = `${sortInfo.field === column.dataIndex ? 'sorted-column' : ''} sortable-column`;
        }
        
        return newColumn;
    });
    
    // Check for Expand column and add if needed
    let processedColumns = [...columnsWithSortIcons];
    if (props.expand && !processedColumns.find(c => c.key === 'Expand')) {
        processedColumns.push({
            title: '',
            dataIndex: rowKey,
            key: 'Expand',
            align: "right",
            onHover: true,  // Important for hover functionality
            render: (id) => (
                <ImageButton src={(id != expandedRowKey) ? ChevronDown : ChevronUp} onClick={() => expandedRowKey = !expandedRowKey} />
            ),
            width: 50,
        });
    }

    // Now add onCell properties to all columns
    const primaryColInd = (props.columns || []).findIndex(column => column.primaryCol);
    
    const finalColumns = processedColumns.map((column, i) => ({
        ...column,
        onCell: (record) => ({
            record,
            onHover: column.onHover,
            primaryCol: primaryColInd === -1 ? (i === 0) : (i === primaryColInd)
        }),
    }));

    const components = {
        body: {
            row: (rowProps) => {
                var rowKey = rowProps['data-row-key'];
                if (rowKey == 'sectionHeader' || rowKey == 'dateRow') {
                    var rowDataItem = (rowProps.children || []).find(item => (item.key || '').toLowerCase() == 'description') || {};
                    var record = (rowDataItem.props || {}).record || {};
                    return (
                        <tr key={`group-${random(10000)}`} className="group-header">
                            <td colSpan={props.columns.length}>{record.date || record.header}</td>
                        </tr>
                    );
                }
                
                // Find the total number of columns in the table
                // This ensures we get the actual rendered columns, not just what's in the columns array
                const totalColumns = props.columns ? 
                    // Calculate based on column definitions (add 1 if expand column exists but not included)
                    (props.columns.length + (props.expand && !props.columns.find(c => c.key === 'Expand') ? 1 : 0)) : 
                    // Or find the number of children in the row (they correspond to cells)
                    (rowProps.children && rowProps.children.length ? rowProps.children.length : 6);
                
                const rowIndex = dataRows.findIndex((item) => item[props.rowKey || props.expandedRowKey] == rowKey);
                const isEvenRow = rowIndex % 2 === 0;
                const isExpanded = props.expandedRowKey ? (rowKey === props.expandedRowKey) : false; // null & undefined case handled

                return (
                    <>
                        <tr {...rowProps} className={`${(!isEvenRow && rowIndex != -1) ? 'odd-row' : 'even-row'} ${isExpanded && 'expanded-parent'}`} />
                        {
                            isExpanded &&
                            <tr className={`expanded-row ${isEvenRow ? 'even-row' : 'odd-row'}`}>
                                <td colSpan={totalColumns}>
                                    {props.getRowDetails(dataRows[rowIndex])}
                                </td>
                            </tr>
                        }
                    </>
                );
            },
            cell: (cellProps) => {
                const { onHover, primaryCol } = cellProps;
                
                if (onHover) {
                    return <td {...cellProps} className={'hover-column' + (primaryCol ? ' primary-column' : '')} />;
                }
                return <td {...cellProps} className={primaryCol ? 'primary-column' : ''} />;
            },
        },
    };

    return (
        <FlexColumn fullWidth gap='0px'>
            {
                titleText &&
                <StyledHeader isCollapsed={isCollapsed} borderView={props.borderView}>
                    <Flex centerHorizontally between gap='16px' style={{ padding: isCollapsed ? '10px 20px' : '20px', minHeight: isCollapsed ? '40px' : '85px' }}>
                        <FlexColumn gap={descText && '6px'}>
                            <Text margin='0' weight={500} size='18px' color={theme.colors.primary2}>
                                {titleText}
                            </Text>
                            {
                                !isCollapsed &&
                                <Text color={theme.colors.defaultLightText}>
                                    {descText}
                                </Text>
                            }
                        </FlexColumn>
                        <Flex start centerHorizontally gap='48px'>
                            {ctaSecondary || null}
                            {ctaContent || null}
                            {
                                canCollapse &&
                                <ImageButton src={isCollapsed ? ChevronDown : ChevronUp} onClick={() => setIsCollapsed(!isCollapsed)} />
                            }
                        </Flex>
                    </Flex>
                </StyledHeader>
            }
            {titleText && !isCollapsed && <Divider color={theme.colors.divider} margin='0px' />}
            {
                !isCollapsed &&
                <>
                    <StyledTable
                        dataCount={(props.dataSource || []).length}
                        {...props}
                        columns={finalColumns}
                        components={components}
                        pagination={pagination || false}
                        hideHeader={hideHeader || false}
                        onChange={handleTableChange}
                        sortDirections={sortDirectionsArray}
                        defaultSortOrder={initialSortOrder}
                        expandable={!!props.expand}
                        showSorterTooltip={false}
                    />

                    {
                        onLoadMore && moreToLoad &&
                        <Flex fullWidth centerVertically style={{ marginTop: 10 }}><TextButton text={`LOAD ${pageSize} MORE`} loading={loadingMore} onClick={onLoadMore} rightIcon={<img style={{ cursor: 'pointer', marginBottom: 1 }} width='24px' height='24px' src={ChevronDownPrimary} />} /></Flex>
                    }
                </>
            }
            {bottomDivider && <Divider color={hexToRgba(theme.colors.divider, 0.4)} margin='0px 5px' />}
        </FlexColumn>
    );
};

export default withTheme(TableView);